"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("./common");
var openModal_1 = __importDefault(require("dingtalk-jsapi/api/biz/util/openModal"));
function pc(params) {
    return new Promise(function (res, rej) {
        var url = common_1.getCRMAuthUrl(params);
        openModal_1.default({
            url: url,
            size: 'small',
            title: '数据授权',
            onSuccess: function (result) {
                if (result === 'success') {
                    res && res(result);
                }
                else {
                    rej && rej(result);
                }
            },
            onFail: function () { },
        });
    });
}
exports.default = pc;
